export const SNAPSHOT_REPORT_SKU = 'ST';
export const SNAPSHOT_REPORT_REFRESH_SKU = 'snapshotreportrefresh';
export const REPUTATION_MANGEMENT_SKU = 'RM';
